var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemovePowerup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 88.9167C25.908 88.9167 8 70.8221 8 48.5C8 26.1779 25.908 8.08333 48 8.08333C70.092 8.08333 88 26.1779 88 48.5C88 70.8221 70.092 88.9167 48 88.9167ZM48 80.8333C56.4869 80.8333 64.6263 77.4268 70.6274 71.3631C76.6286 65.2994 80 57.0753 80 48.5C80 39.9247 76.6286 31.7006 70.6274 25.6369C64.6263 19.5732 56.4869 16.1667 48 16.1667C39.5131 16.1667 31.3737 19.5732 25.3726 25.6369C19.3714 31.7006 16 39.9247 16 48.5C16 57.0753 19.3714 65.2994 25.3726 71.3631C31.3737 77.4268 39.5131 80.8333 48 80.8333ZM48 42.7851L59.312 31.3512L64.972 37.0702L53.656 48.5L64.972 59.9298L59.312 65.6488L48 54.2149L36.688 65.6488L31.028 59.9298L42.344 48.5L31.028 37.0702L36.688 31.3512L48 42.7851Z",
    fill: "#413C35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovePowerup);
export default __webpack_public_path__ + "static/media/remove-powerup.088dfd4663ba23cfbd0d6137d94cca08.svg";
export { ForwardRef as ReactComponent };